import styled, { createGlobalStyle } from 'styled-components';

import { palette } from '../../styles';


const GlobalStyle = createGlobalStyle`
  .Toastify__toast--error {
    background: ${palette.dangerPrimary};
	}
	.Toastify__close-button {
    position: absolute;
		top: 4px;
		right: 4px;
	}
`;

const ErrorLayout = styled.div`
	position: relative;
	width: 100%;
	max-width: 100%;
	min-height: 80px;
	display: flex;
	flex-flow: column nowrap;
	justify-content: space-between;
	align-items: center;
`;

const ErrorContentLayout = styled.div`
	align-self: center;
	margin-bottom: 10px;
`;

export {
	GlobalStyle,
	ErrorLayout,
	ErrorContentLayout,
};
